function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import { styled } from '@mui/material/styles';
import Tab, { tabClasses } from '@mui/material/Tab';
const StyledTab = styled(Tab)(_ref => {
  let {
    theme: {
      palette,
      spacing,
      typography
    }
  } = _ref;
  const height = spacing(6);
  return {
    border: '2px solid transparent',
    color: palette.text.primary,
    minHeight: height,
    minWidth: spacing(6),
    padding: [[0, spacing(2)]],
    ...typography.button,
    '&[class*="focusVisible"]': {
      borderColor: palette.primary.main
    },
    ["& > .".concat(tabClasses.iconWrapper)]: {
      fontSize: spacing(2),
      marginRight: spacing(0.5)
    },
    ["&.".concat(tabClasses.labelIcon)]: {
      minHeight: height
    }
  };
});

/**
 * This component can be used with `SovosTabs` to render a tab bar.
 * However, `SovosTabContents` and `SovosTabGroup` will generate tabs and
 * handle tab switching and should be used in most situations.
 */
const SovosTab = _ref2 => {
  let {
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledTab, _extends({
    className: clsx('sovosTab', className),
    iconPosition: "start",
    disableRipple: true
  }, rest));
};
SovosTab.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosTab.baseComponent = {
  name: 'Tab',
  link: 'tab/'
};
export default SovosTab;